import React from "react";
import { ArrowRight, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrecisionInEveryPillar() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="11837" id="australias-bulk-material-partner" className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-background dark">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/60 z-10" /> {}
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/cinematic_crane_wireframe.png)] bg-cover bg-center grayscale-[20%] opacity-90" role="img" aria-label="High-quality construction materials featuring steel rebar and concrete textures" />
        {}
        <div className="absolute inset-0 z-10 opacity-30 pointer-events-none" style={{
        backgroundImage: `
              linear-gradient(to right, rgba(255, 255, 255, 0.05) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
            `,
        backgroundSize: '3rem 3rem'
      }} />
        {}
        <div className="absolute inset-0 z-10 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,0.7)_100%)]" />
      </div>

      {}
      <div ref={ref} className={`relative z-20 container mx-auto px-4 md:px-6 text-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="max-w-5xl mx-auto space-y-8">
          {}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter uppercase font-serif">
            <span className="block text-[var(--ring)] drop-shadow-sm mb-2">
              Brendon J
            </span>
            <span className="bg-gradient-to-b from-white to-gray-300 bg-clip-text text-transparent drop-shadow-md">
              Australia&apos;s Bulk Material Backbone
            </span>
          </h1>

          {}
          <p className="text-lg md:text-2xl text-gray-200 max-w-3xl mx-auto font-sans font-light leading-relaxed drop-shadow-md">
            The reliable wholesale partner for Australian construction. Delivering high-capacity bulk orders of cement, steel, and hardware compliant with national standards.
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button asChild size="lg" className="bg-[var(--ring)] hover:bg-[var(--ring)]/90 text-[var(--primary)] font-bold border-none rounded-sm px-8 h-14 text-base tracking-wide shadow-[0_4px_20px_rgba(251,191,36,0.4)] transition-transform hover:scale-105">
              <Link to="/ContactPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive has-[>svg]:px-4 bg-[var(--ring)] font-bold border-none rounded-sm px-8 h-14 text-base tracking-wide shadow-[0_4px_20px_rgba(251,191,36,0.4)] transition-transform !text-[hsl(0,0%,0%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-[var(--ring)]/90 hover:scale-105">
                Get Bulk Quote
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="border-white/40 text-white hover:bg-white/10 hover:text-white hover:border-white rounded-sm px-8 h-14 text-base tracking-wide backdrop-blur-md transition-all font-mono">
              <Link to="/ProductsPage">
                View Inventory
                <ChevronRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[var(--ring)]/30 to-transparent z-20" />
    </section>;
}